import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@kss/auth';

export default function Login() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  const requestedFrom = (location.state as { from?: { pathname?: string } } | null)
    ?.from?.pathname;

  const target =
    requestedFrom && requestedFrom.startsWith('/panel')
      ? requestedFrom
      : '/panel/dashboard';

  useEffect(() => {
    if (isAuthenticated) return;

    setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent('kss:open-login', {
          detail: { redirect: target },
        })
      );
    }, 0);
  }, [isAuthenticated, target]);

  if (isAuthenticated) {
    return <Navigate to={target} replace />;
  }

  return <Navigate to="/" replace />;
}


// import { useEffect } from 'react';
// import { Navigate, useLocation } from 'react-router-dom';
// import { useAuth } from '@kss/auth';

// /**
//  * `/login` is now a thin redirector — the modal supersedes the standalone
//  * page. Keeping the route preserves bookmarked links and `RequireAuth`'s
//  * default `redirectTo`.
//  *
//  * Behaviour:
//  * - Authenticated users hitting `/login` are forwarded straight to
//  *   `/panel/dashboard` (or back to whichever path `RequireAuth` saved).
//  * - Unauthenticated users land on `/`, and we dispatch `kss:open-login` so
//  *   the global modal pops open immediately. `detail.redirect` carries the
//  *   originally-requested protected URL through the sign-in flow.
//  */
// export default function Login() {
//   const location = useLocation();
//   const { isAuthenticated } = useAuth();
//   const requestedFrom = (location.state as { from?: { pathname?: string } } | null)?.from?.pathname;
//   const target = requestedFrom && requestedFrom.startsWith('/panel') ? requestedFrom : '/panel/dashboard';

//   useEffect(() => {
//     if (isAuthenticated) return;
//     window.dispatchEvent(
//       new CustomEvent('kss:open-login', { detail: { redirect: target } })
//     );
//   }, [isAuthenticated, target]);

//   if (isAuthenticated) {
//     return <Navigate to={target} replace />;
//   }
//   return <Navigate to="/" replace />;
// }
